import { getValidClassNames } from "@/utils";
import { CardProps } from "./Card.interfaces";

export const Card = ({ additionalClassNames, children }: CardProps) => {
  return(
    <div className={getValidClassNames({
      "bg-white border border-grey-300 shadow-xl rounded-lg p-8 rounded-lg h-full": true,
      [String(additionalClassNames)]: Boolean(additionalClassNames)
    })}>
      {children}
    </div>
  )
};